import localeEn from './en.json';

const messages = {
    'en': localeEn,
};

const clientLanguage = navigator.language.split(/[-_]/)[0];
export const systemLanguage = messages[clientLanguage] !== undefined ? clientLanguage : 'en';
export const systemMessages = messages[systemLanguage];